function cov_wesi2171() {
  var path = "/app/src/components/shadow-view/index.tsx";
  var hash = "36cde86d371a23ddaedad7a384f7cdb9b2cabeab";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/shadow-view/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "36cde86d371a23ddaedad7a384f7cdb9b2cabeab"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_wesi2171 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_wesi2171();
export { ShadowView } from './shadow-view';